<script>
export default {
    name: "mineInput",
    props: { 
        value: String,
        placeholder: String,
        type: {
            type: String,
            default: 'text'
        },
        maxlength: {
            default: 140
        }
    },
    data() {
        return {};
    },
    computed: {},
    components: {
        
    },
    mounted() {},
    destroyed() {},
    watch: {},
    methods: {
        inputChange(e) {
            this.$emit("input", e.target.value);
        },
        focus(){
            this.$refs.input.focus();
        },
        enter(){
            this.$emit('enter');
        },
    },
};
</script>

<template>
    <div class="input_wrap" :class="{has_value: value != ''}">
        <div class="text">{{placeholder}}</div>
        <input :type="type" ref="input" :value="value" @input="inputChange" :maxlength="maxlength" @keyup.enter="enter"/>
    </div>
</template>

<style scoped lang="scss">
@import '@/assets/css/input.scss';
.input_wrap{
    @include input_wrap;
}
</style>